"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformacionLaboralParte2 = void 0;
var React = require("react");
var required_select_js_1 = require("../utils/required_select.js");
var Clases = require("../../clases_comunes");
var OpcionesList = require("../../opciones.js");
var TrianguloPurpura = require("../../assets/img/PurpuraPng.png");
var InformacionLaboralParte2 = /** @class */ (function (_super) {
    __extends(InformacionLaboralParte2, _super);
    function InformacionLaboralParte2(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            infolaboral: new Clases.InfoLaboral(),
            vermas_preg11: false
        };
        // METODOS
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSelectChange = _this.handleSelectChange.bind(_this);
        _this.validarAvanceSiguiente = _this.validarAvanceSiguiente.bind(_this);
        _this.mostrarVerMas = _this.mostrarVerMas.bind(_this);
        _this.ocultarVerMas = _this.ocultarVerMas.bind(_this);
        return _this;
    }
    InformacionLaboralParte2.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({ infolaboral: this.props.infolaboral }, function () {
            _this.cargarPreguntasAll();
        });
    };
    InformacionLaboralParte2.prototype.cargarPreguntasAll = function () {
        var _this = this;
        var laboralI = this.state.infolaboral;
        Object.keys(laboralI).map(function (key, i) {
            _this.showNewQuestions("inflab-" + key, laboralI[key]);
        });
    };
    InformacionLaboralParte2.prototype.handleChange = function (event) {
        if (event.target.name.startsWith("inflab")) {
            var tnameil = event.target.name.split("-");
            var dtolaboral = this.state.infolaboral;
            if (tnameil[1] === "salariomensual") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 9);
            }
            else if (tnameil[1] === "motivotrabajonr ") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 999);
            }
            else if (tnameil[1] === "nombrejefeinmediato ") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 99);
            }
            else if (tnameil[1] === "cargojefeinmediato ") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 99);
            }
            else if (tnameil[1] === "emailjefeinmediato") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 99);
            }
            else if (tnameil[1] === "motivoestudiar") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 999);
            }
            else if (tnameil[1] === "otraareadesempeno") {
                dtolaboral[tnameil[1]] = event.target.value.slice(0, 74);
            }
            else {
                dtolaboral[tnameil[1]] = event.target.value;
            }
            this.setState({ infolaboral: dtolaboral });
            this.showNewQuestions(event.target.name, event.target.value);
        }
    };
    InformacionLaboralParte2.prototype.handleSelectChange = function (selectedOption, selName) {
        var _this = this;
        if (selectedOption != null) {
            if (selName.name.startsWith("inflab")) {
                var tnameils = selName.name.split("-");
                var dtolaboral = this.state.infolaboral;
                dtolaboral[tnameils[1]] = selectedOption.value;
                this.setState({ infolaboral: dtolaboral }, function () {
                    _this.showNewQuestions(selName.name, selectedOption.value);
                });
            }
        }
    };
    InformacionLaboralParte2.prototype.showNewQuestions = function (name, answer) {
        if (name.startsWith("inflab")) {
            var tnamels = name.split("-");
            var dtoinfolabshow = this.state.infolaboral;
            if (tnamels[1] === "situacionlaboral") {
                if (answer === "ND") {
                    dtoinfolabshow["dedicacionreldepen"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["relacioncarrera"] = "";
                    dtoinfolabshow["motivotrabajonr"] = "";
                    dtoinfolabshow["nombreempresa"] = "";
                    dtoinfolabshow["emailempresa"] = "";
                    dtoinfolabshow["idpais"] = 0;
                    dtoinfolabshow["sectorempresa"] = 0;
                    dtoinfolabshow["cargoempresa"] = "";
                    dtoinfolabshow["niveldocencia"] = "";
                    dtoinfolabshow["cantpersonascargo"] = 0;
                    dtoinfolabshow["aniosexperiencia"] = 0;
                    dtoinfolabshow["salariomensual"] = 0;
                    dtoinfolabshow["idiomatrabajo"] = "";
                    dtoinfolabshow["tipocomunicacion"] = "";
                    dtoinfolabshow["tiempoprimertrabajo"] = "";
                    dtoinfolabshow["primertrabajo"] = "";
                    dtoinfolabshow["tamanioempresa"] = "";
                    dtoinfolabshow["cargojefeinmediato"] = "";
                    dtoinfolabshow["nombrejefeinmediato"] = "";
                    dtoinfolabshow["emailjefeinmediato"] = "";
                    dtoinfolabshow["idprovincia"] = 0;
                    dtoinfolabshow["idcanton"] = 0;
                    dtoinfolabshow["nombreempresafactura"] = "";
                    dtoinfolabshow["modalidadtrabajo"] = "";
                    dtoinfolabshow["areadesempeno"] = "";
                    dtoinfolabshow["otraareadesempeno"] = "";
                    dtoinfolabshow["horassemanales"] = 0;
                    dtoinfolabshow["trabajoambiente"] = "";
                    dtoinfolabshow["contactarceproem"] = "";
                }
                else if (answer === "BPT" || answer === "SE") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionreldepen"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["relacioncarrera"] = "";
                    dtoinfolabshow["motivotrabajonr"] = "";
                    dtoinfolabshow["nombreempresa"] = "";
                    dtoinfolabshow["emailempresa"] = "";
                    dtoinfolabshow["idpais"] = 0;
                    dtoinfolabshow["sectorempresa"] = 0;
                    dtoinfolabshow["cargoempresa"] = "";
                    dtoinfolabshow["niveldocencia"] = "";
                    dtoinfolabshow["cantpersonascargo"] = 0;
                    dtoinfolabshow["aniosexperiencia"] = 0;
                    dtoinfolabshow["salariomensual"] = 0;
                    dtoinfolabshow["idiomatrabajo"] = "";
                    dtoinfolabshow["tipocomunicacion"] = "";
                    dtoinfolabshow["tiempoprimertrabajo"] = "";
                    dtoinfolabshow["primertrabajo"] = "";
                    dtoinfolabshow["tamanioempresa"] = "";
                    dtoinfolabshow["cargojefeinmediato"] = "";
                    dtoinfolabshow["nombrejefeinmediato"] = "";
                    dtoinfolabshow["emailjefeinmediato"] = "";
                    dtoinfolabshow["idprovincia"] = 0;
                    dtoinfolabshow["idcanton"] = 0;
                    dtoinfolabshow["modalidadtrabajo"] = "";
                    dtoinfolabshow["areadesempeno"] = "";
                    dtoinfolabshow["otraareadesempeno"] = "";
                    dtoinfolabshow["horassemanales"] = 0;
                    dtoinfolabshow["nombreempresafactura"] = "";
                    dtoinfolabshow["trabajoambiente"] = "";
                    dtoinfolabshow["contactarceproem"] = "";
                    //if (answer === "PN") { dtoinfolabshow["negociopropio"] = "S"; }
                }
                else if (answer === "PN") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionreldepen"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["relacioncarrera"] = "";
                    dtoinfolabshow["motivotrabajonr"] = "";
                    dtoinfolabshow["nombreempresa"] = "";
                    dtoinfolabshow["emailempresa"] = "";
                    dtoinfolabshow["idpais"] = 0;
                    dtoinfolabshow["sectorempresa"] = 0;
                    dtoinfolabshow["cargoempresa"] = "";
                    dtoinfolabshow["niveldocencia"] = "";
                    dtoinfolabshow["cantpersonascargo"] = 0;
                    dtoinfolabshow["aniosexperiencia"] = 0;
                    dtoinfolabshow["salariomensual"] = 0;
                    dtoinfolabshow["idiomatrabajo"] = "";
                    dtoinfolabshow["tipocomunicacion"] = "";
                    dtoinfolabshow["tiempoprimertrabajo"] = "";
                    dtoinfolabshow["primertrabajo"] = "";
                    dtoinfolabshow["tamanioempresa"] = "";
                    dtoinfolabshow["cargojefeinmediato"] = "";
                    dtoinfolabshow["nombrejefeinmediato"] = "";
                    dtoinfolabshow["emailjefeinmediato"] = "";
                    dtoinfolabshow["idprovincia"] = 0;
                    dtoinfolabshow["idcanton"] = 0;
                    dtoinfolabshow["modalidadtrabajo"] = "";
                    dtoinfolabshow["areadesempeno"] = "";
                    dtoinfolabshow["otraareadesempeno"] = "";
                    dtoinfolabshow["horassemanales"] = 0;
                    dtoinfolabshow["nombreempresafactura"] = "";
                    dtoinfolabshow["trabajoambiente"] = "";
                    dtoinfolabshow["contactarceproem"] = "";
                    dtoinfolabshow["negociopropio"] = "S";
                    dtoinfolabshow["nombrenp"] = "NA";
                }
                else if (answer === "TRD") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["nombreempresafactura"] = "";
                    dtoinfolabshow["contactarceproem"] = "";
                    if (this.props.graduadoPost) {
                        dtoinfolabshow["tiempoprimertrabajo"] = "";
                        dtoinfolabshow["primertrabajo"] = "";
                    }
                }
                else if (answer === "PEI") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionreldepen"] = "";
                    dtoinfolabshow["contactarceproem"] = "";
                    if (this.props.graduadoPost) {
                        dtoinfolabshow["tiempoprimertrabajo"] = "";
                        dtoinfolabshow["primertrabajo"] = "";
                    }
                }
                else if (answer === "RDN") {
                    dtoinfolabshow["motivond"] = "";
                    dtoinfolabshow["dedicacionejerindep"] = "";
                    dtoinfolabshow["contactarceproem"] = "";
                    dtoinfolabshow["negociopropio"] = "S";
                    if (this.props.graduadoPost) {
                        dtoinfolabshow["tiempoprimertrabajo"] = "";
                        dtoinfolabshow["primertrabajo"] = "";
                    }
                }
            }
            else if (tnamels[1] === "motivond") {
            }
            else if (tnamels[1] === "relacioncarrera") {
                if (answer === "NR") {
                }
                else if (answer !== "" && answer !== null && answer !== "NR") {
                    dtoinfolabshow["motivotrabajonr"] = "";
                }
            }
            else if (tnamels[1] === "cargoempresa") {
                if (answer === "DO") {
                }
                else if (answer !== "" && answer !== null && answer !== "DO") {
                    dtoinfolabshow["niveldocencia"] = "";
                }
            }
            else if (tnamels[1] === "idiomatrabajo") {
                if (answer === "N" || answer === "" || answer === null) {
                    dtoinfolabshow["tipocomunicacion"] = "";
                }
                else if (answer !== "" && answer !== null && answer !== "N") {
                    //(document.getElementById("tipocomunpregunta") as HTMLInputElement).style.removeProperty("display");
                }
            }
            else if (tnamels[1] === "negociopropio") {
                if (answer === "N") {
                    dtoinfolabshow["dedicacionnp"] = "";
                    dtoinfolabshow["aniosnp"] = 0;
                    dtoinfolabshow["relacionnpcarrera"] = "";
                    dtoinfolabshow["sectornp"] = 0;
                    dtoinfolabshow["nombrenp"] = "NA";
                    dtoinfolabshow["productonp"] = "";
                }
            }
            else if (tnamels[1] === "idpais") {
                if (answer === 1) {
                    //(document.getElementById("localidad-empresa") as HTMLInputElement).style.removeProperty("display");
                }
                else if (answer !== 0 && answer !== null && answer !== 1) {
                    dtoinfolabshow["idprovincia"] = 0;
                    dtoinfolabshow["idcanton"] = 0;
                }
            }
            else if (tnamels[1] === "areadesempeno") {
                if (answer !== "O") {
                    dtoinfolabshow["otraareadesempeno"] = "";
                }
            }
            this.setState({ infolaboral: dtoinfolabshow });
        }
    };
    InformacionLaboralParte2.prototype.validarAvanceSiguiente = function (event) {
        event.preventDefault();
        this.props.validarCambiosSeccion(event, this.state.infolaboral);
    };
    InformacionLaboralParte2.prototype.mostrarVerMas = function () {
        this.setState({ vermas_preg11: true });
    };
    InformacionLaboralParte2.prototype.ocultarVerMas = function () {
        this.setState({ vermas_preg11: false });
    };
    InformacionLaboralParte2.prototype.render = function () {
        return (React.createElement("form", { id: "alumniform-laboral-p2", name: "alumniform-laboral-p2", onSubmit: this.validarAvanceSiguiente },
            React.createElement("div", { className: "purple-border", style: { paddingLeft: "20px", paddingRight: "20px" } },
                React.createElement("div", { id: "informacion-laboral" },
                    React.createElement("div", { className: "form-group row section-title" },
                        React.createElement("div", { style: { backgroundColor: "white" } },
                            React.createElement("img", { src: TrianguloPurpura, alt: "", className: "small-icon", style: { width: "50px", height: "50px" } }),
                            React.createElement("h5", { className: "down purple-text small-h5title" }, "INFORMACI\u00D3N LABORAL - PARTE 2"))),
                    React.createElement("br", null),
                    (this.state.infolaboral.situacionlaboral !== "BPT" && this.state.infolaboral.situacionlaboral !== "SE" && this.state.infolaboral.situacionlaboral !== "ND" && this.state.infolaboral.situacionlaboral !== "PN" && this.state.infolaboral.situacionlaboral !== "") && (React.createElement("div", { className: "form-group row" },
                        React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingRight: "5px" } },
                            React.createElement("label", { className: "control-label", htmlFor: "trabambiente" },
                                "En su trabajo actual, \u00BFrealiza actividades que contribuyen a preservar o restaurar el medio ambiente, ya sea directa o indirectamente? ",
                                React.createElement("span", { className: "required-field" }, "*"),
                                (!this.state.vermas_preg11) && (React.createElement("span", { style: { fontSize: "small", color: "red", textDecoration: "underline", cursor: "pointer" }, onClick: this.mostrarVerMas }, "...ver m\u00E1s"))),
                            (this.state.vermas_preg11) && (React.createElement(React.Fragment, null,
                                React.createElement("span", { style: { fontSize: "small" } },
                                    "Esto puede incluir acciones como:",
                                    React.createElement("ul", null,
                                        React.createElement("li", null, "Mejorar la eficiencia en el uso de energ\u00EDa y materiales."),
                                        React.createElement("li", null, "Limitar las emisiones de gases de efecto invernadero."),
                                        React.createElement("li", null, "Minimizar residuos y contaminaci\u00F3n."),
                                        React.createElement("li", null, "Proteger y restaurar ecosistemas."),
                                        React.createElement("li", null, "Apoyar la adaptaci\u00F3n a los efectos del cambio clim\u00E1tico."))),
                                React.createElement("span", { className: "control-label", style: { fontSize: "small", textDecoration: "underline", cursor: "pointer" }, onClick: this.ocultarVerMas }, "...ocultar"))),
                            React.createElement(required_select_js_1.default, { options: OpcionesList.YesNoList, name: "inflab-trabajoambiente", id: "trabambiente", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infolaboral.trabajoambiente ? this.state.infolaboral.trabajoambiente : '', isDisabled: false, required: this.state.infolaboral.situacionlaboral === "TRD" || this.state.infolaboral.situacionlaboral === "PEI" || this.state.infolaboral.situacionlaboral === "RDN", isMulti: false })),
                        React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingLeft: "5px" } },
                            React.createElement("label", { className: "control-label", htmlFor: "cantpersonascargo", style: { marginTop: "22px" } }, "\u00BFCu\u00E1ntas personas tiene actualmente a su cargo?"),
                            React.createElement("input", { className: "form-control form-control-sm", type: "number", value: this.state.infolaboral.cantpersonascargo > 0 ? this.state.infolaboral.cantpersonascargo : '', name: "inflab-cantpersonascargo", id: "cantpersonascargo", onChange: this.handleChange, onKeyDown: this.props.exceptionsInput })))),
                    (this.state.infolaboral.situacionlaboral !== "BPT" && this.state.infolaboral.situacionlaboral !== "SE" && this.state.infolaboral.situacionlaboral !== "ND" && this.state.infolaboral.situacionlaboral !== "PN" && this.state.infolaboral.situacionlaboral !== "") && (React.createElement("div", { className: "form-group row" },
                        React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingRight: "5px" } },
                            React.createElement("label", { className: "control-label", htmlFor: "salariomensual" },
                                "\u00BFCu\u00E1l es su salario mensual actual en d\u00F3lares (USD)? ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement("input", { className: "form-control form-control-sm", type: "number", value: this.state.infolaboral.salariomensual > 0 ? this.state.infolaboral.salariomensual : '', name: "inflab-salariomensual", id: "salariomensual", onChange: this.handleChange, onKeyDown: this.props.exceptionsInput, required: this.state.infolaboral.situacionlaboral === "TRD" || this.state.infolaboral.situacionlaboral === "PEI" || this.state.infolaboral.situacionlaboral === "RDN" })),
                        React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingLeft: "5px" } },
                            React.createElement("label", { className: "control-label", htmlFor: "idiomaemp" },
                                "\u00BFQu\u00E9 idioma, adem\u00E1s del espa\u00F1ol maneja en su \u00E1mbito laboral? ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement(required_select_js_1.default, { options: OpcionesList.IdiomasList, name: "inflab-idiomatrabajo", id: "idiomaemp", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infolaboral.idiomatrabajo ? this.state.infolaboral.idiomatrabajo : '', isDisabled: false, required: this.state.infolaboral.situacionlaboral === "TRD" || this.state.infolaboral.situacionlaboral === "PEI" || this.state.infolaboral.situacionlaboral === "RDN", isMulti: false })))),
                    (this.state.infolaboral.idiomatrabajo !== "N" && this.state.infolaboral.idiomatrabajo !== "" && this.state.infolaboral.idiomatrabajo !== null) && (React.createElement("div", { className: "form-group row", id: "tipocomunpregunta" },
                        React.createElement("div", { className: "col-md-6 two-col-row" }),
                        React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingLeft: "5px" } },
                            React.createElement("label", { className: "control-label", htmlFor: "comunicacionemp" },
                                "\u00BFQu\u00E9 forma de comunicaci\u00F3n es m\u00E1s frecuente? ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement(required_select_js_1.default, { options: OpcionesList.TipocomunicacionList, name: "inflab-tipocomunicacion", id: "comunicacionemp", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infolaboral.tipocomunicacion ? this.state.infolaboral.tipocomunicacion : '', isDisabled: false, required: this.state.infolaboral.idiomatrabajo !== "N", isMulti: false })))),
                    (!this.props.graduadoPost && this.state.infolaboral.situacionlaboral !== "BPT" && this.state.infolaboral.situacionlaboral !== "SE" && this.state.infolaboral.situacionlaboral !== "ND" && this.state.infolaboral.situacionlaboral !== "PN" && this.state.infolaboral.situacionlaboral !== "") && (React.createElement("div", { className: "form-group row" },
                        React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingRight: "5px" } },
                            React.createElement("label", { className: "control-label", htmlFor: "tiempodespgrad" },
                                "\u00BFCu\u00E1nto tiempo le tom\u00F3 encontrar trabajo despu\u00E9s de la graduaci\u00F3n? ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement(required_select_js_1.default, { options: this.props.opcionesPrimerTrabajo, name: "inflab-tiempoprimertrabajo", id: "tiempodespgrad", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infolaboral.tiempoprimertrabajo ? this.state.infolaboral.tiempoprimertrabajo : '', isDisabled: false, required: this.state.infolaboral.situacionlaboral === "TRD" || this.state.infolaboral.situacionlaboral === "PEI" || this.state.infolaboral.situacionlaboral === "RDN", isMulti: false })),
                        React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingLeft: "5px" } },
                            React.createElement("label", { className: "control-label", htmlFor: "howprimeremp" },
                                "\u00BFC\u00F3mo consigui\u00F3 su primer empleo? ",
                                React.createElement("span", { className: "required-field" }, "*")),
                            React.createElement(required_select_js_1.default, { options: OpcionesList.ComoprimtrabList, name: "inflab-primertrabajo", id: "howprimeremp", placeholder: "Elija una opci\u00F3n...", onChange: this.handleSelectChange, value: this.state.infolaboral.primertrabajo ? this.state.infolaboral.primertrabajo : '', isDisabled: false, required: (this.state.infolaboral.situacionlaboral === "TRD" || this.state.infolaboral.situacionlaboral === "PEI" || this.state.infolaboral.situacionlaboral === "RDN") && !this.props.graduadoPost, isMulti: false })))),
                    (this.state.infolaboral.situacionlaboral !== "BPT" && this.state.infolaboral.situacionlaboral !== "SE" && this.state.infolaboral.situacionlaboral !== "ND" && this.state.infolaboral.situacionlaboral !== "PN" && this.state.infolaboral.situacionlaboral !== "") && (React.createElement("div", { className: "form-group row", style: { marginBottom: "0px" } },
                        React.createElement("div", { className: "col-md-6 two-col-row" },
                            " ",
                            React.createElement("label", { className: "control-label", htmlFor: "contactojefeinmedi" }, "Si est\u00E1 de acuerdo, proporcione el contacto de su Jefe inmediato (esta informaci\u00F3n ser\u00E1 usada exclusivamente para temas de rankings ESPOL)")))),
                    (this.state.infolaboral.situacionlaboral !== "BPT" && this.state.infolaboral.situacionlaboral !== "SE" && this.state.infolaboral.situacionlaboral !== "ND" && this.state.infolaboral.situacionlaboral !== "PN" && this.state.infolaboral.situacionlaboral !== "") && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "form-group row", style: { marginBottom: "0px" } },
                            React.createElement("div", { className: "col-md-6 jefe-row", style: { paddingLeft: "30px" } },
                                React.createElement("label", { className: "control-label", htmlFor: "nombrejefeinmed" }, "Nombre:"),
                                React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.infolaboral.nombrejefeinmediato, name: "inflab-nombrejefeinmediato", id: "nombrejefeinmed", maxLength: 99, onChange: this.handleChange, onKeyDown: this.props.exceptionsTextInput })),
                            React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingLeft: "5px" } })),
                        React.createElement("div", { className: "form-group row", style: { marginBottom: "0px" } },
                            React.createElement("div", { className: "col-md-6 jefe-row", style: { paddingLeft: "30px" } },
                                React.createElement("label", { className: "control-label", htmlFor: "cargojefeinmed" }, "Cargo:"),
                                React.createElement("input", { className: "form-control form-control-sm", type: "text", value: this.state.infolaboral.cargojefeinmediato, name: "inflab-cargojefeinmediato", id: "cargojefeinmed", maxLength: 99, onChange: this.handleChange, onKeyDown: this.props.exceptionsTextInput })),
                            React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingLeft: "5px" } })),
                        React.createElement("div", { className: "form-group row", style: { marginBottom: "0px" } },
                            React.createElement("div", { className: "col-md-6 jefe-row", style: { paddingLeft: "30px" } },
                                React.createElement("label", { className: "control-label", htmlFor: "emailjefeinmed" }, "Correo institucional:"),
                                React.createElement("input", { className: "form-control form-control-sm", type: "email", value: this.state.infolaboral.emailjefeinmediato, name: "inflab-emailjefeinmediato", id: "emailjefeinmed", maxLength: 99, onChange: this.handleChange, onKeyDown: this.props.exceptionsTextInput, placeholder: "Ej: nombre@dominioempresa" })),
                            React.createElement("div", { className: "col-md-6 two-col-row", style: { paddingLeft: "5px" } })))),
                    React.createElement("br", null),
                    React.createElement("div", null,
                        React.createElement("label", { style: { fontSize: "large" } },
                            "(",
                            React.createElement("span", { className: "required-field" }, "*"),
                            ") Campos requeridos")))),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("div", { className: "form-group row", id: "siguiente-laboral-p2", style: { float: "right" } },
                React.createElement("button", { type: "button", name: "prev-laboral-p2-button", id: "prev-laboral-p2-button", className: "btn btn-info buttonSpace", onClick: this.props.retrocederSeccion }, "Anterior"),
                React.createElement("button", { type: "submit", className: "btn btn-info buttonSpace" }, "Siguiente")),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null)));
    };
    return InformacionLaboralParte2;
}(React.Component));
exports.InformacionLaboralParte2 = InformacionLaboralParte2;
//# sourceMappingURL=InformacionLaboralParte2.js.map